export default __webpack_public_path__ + "static/media/logo_white.811f9ef7.svg";